import { lazy, Suspense } from 'react';
import IndicatorPageLoader from 'navigation/loaders/Indicator';

const Page = lazy(() => import('./component'));

export default function OrdersPageLoader() {
  return (
    <Suspense fallback={<IndicatorPageLoader fullPage />}>
      <Page />
    </Suspense>
  );
}
